import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleShipmentAttachment } from "../../actions/ui_actions";

import {
  ActionButton,
  CommandBarButton
} from "office-ui-fabric-react/lib/Button";

class ToggleShipmentAttachmentDialog extends Component {
  render() {
    return (
      <div>
        {this.props.buttonType === "action" ? (
          <div>
            <ActionButton
              onClick={e => {
                e.preventDefault();
                this.props.toggle();
              }}
              styles={{ root: { height: "20px", marginTop: "0px", paddingTop: "0px" } }}
              title="Shipment status"
              iconProps={{
                iconName: "Upload"
                // style: { fontSize: 'x-small' }
              }}
            />
          </div>
        ) : (
          <CommandBarButton
            styles={{ root: { padding: "10px" } }}
            disabled={this.props.shipment.id ? false : true}
            title={`Upload shipment files`}
            iconProps={{ iconName: "Upload" }}
            onClick={e => {
              e.preventDefault();
              this.props.toggle();
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps, {
  toggle: toggleShipmentAttachment
})(ToggleShipmentAttachmentDialog);



// WEBPACK FOOTER //
// ./src/common/Buttons/_ToggleShipmentAttachmentDialog.js